/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Form } from "../../components";
import { connect } from "react-redux";
import "./styles.scss";
import { setCurrentStatus } from "../../actions";
import projectData from "../../config/projectData";
import ProjectSlider from "../../components/ProjectSlider/ProjectSlider";
import { useIsMobile } from "../../utilities/useIsMobile";

function Home({ currentStatus }) {
  const [show, setShow] = useState(0);
  const [selProject, setSelProject] = useState(projectData[0]);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) {
      const footer = document.getElementById("footer");
      if (footer) {
        if (currentStatus === "home") {
          footer.style.display = "block";
        } else {
          footer.style.display = "none";
        }
      }
    }
  }, [currentStatus, isMobile]);

  useEffect(() => {
    if (isMobile) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [currentStatus, isMobile]);

  return (
    <>
      <Helmet>
        <title>Fidweb - Making software people actually love</title>
        <meta name="description" content="Building and upgrading mobile apps, web-based solutions and heavy enterprise programs. Software development company in Bulgaria." />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fidweb.net/" />
        <meta property="og:title" content="Fidweb - Making software people actually love" />
        <meta property="og:description" content="Building and upgrading mobile apps, web-based solutions and heavy enterprise programs. Software development company in Bulgaria." />
        <meta property="og:image" content="https://fidweb.net/screenshot.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://fidweb.net/" />
        <meta name="twitter:title" content="Fidweb - Making software people actually love" />
        <meta name="twitter:description" content="Building and upgrading mobile apps, web-based solutions and heavy enterprise programs. Software development company in Bulgaria." />
        <meta name="twitter:image" content="https://fidweb.net/screenshot.png" />
      </Helmet>
      
      <div className="home-container">
        <div className="only-mobile">
          <div className="home-inner-container">
            {currentStatus !== "home" ? (
              <>
                <div className="left-container"></div>
                <div className="right-container">
                  <Form isMobileLayout />
                </div>
              </>
            ) : (
              <>
                <div className="left-container">
                  <div className="top-container">
                    <h1>Making software people actually love</h1>
                  </div>

                  <div className="text-container">
                    <div className="red-dot" />
                    Building and upgrading mobile apps, web-based solutions and heavy enterprise programs
                  </div>
                  <div className="text-container">
                    <div className="red-dot" />
                    Talented software engineers from Eastern Europe and management team with a global focus
                  </div>
                  <div className="text-container">
                    <div className="red-dot" />
                    Serving to Millions of Users and growing
                  </div>
                  {show ? <Form isMobileLayout /> : ""}
                </div>
                <div className="right-container">
                  <ProjectSlider isMobileLayout setSelProject={setSelProject} selProject={selProject} />
                </div>
              </>
            )}
          </div>
        </div>

        <div className="only-desktop">
          <div
            className={`home-inner-container ${currentStatus !== "home" && "form"}`}
          >
            <div
              className={`left-container ${currentStatus !== "home" && "form"}`}
            >
              {currentStatus !== "home" ? (
                <>
                  <div className="contact-form-collage" />
                </>
              ) : (
                <>
                  <div className="top-container">
                    <h1>Making software people actually love</h1>
                  </div>
                  <div className="text-container">
                    <div className="red-dot" />
                    Building and upgrading mobile apps, web-based solutions and heavy enterprise programs
                  </div>
                  <div className="text-container">
                    <div className="red-dot" />
                    Talented software engineers from Eastern Europe and management team with a global focus
                  </div>
                  <div className="text-container">
                    <div className="red-dot" />
                    Serving to Millions of Users and growing
                  </div>
                  <ProjectSlider setSelProject={setSelProject} selProject={selProject} />
                </>
              )}
            </div>
            <div
              className={`right-container ${currentStatus !== "home" && "form"}`}
            >
              {currentStatus === "home" ? (
                <div className="selected-project-container">
                  <div className="project-info">
                    <h2 className="project-text">{selProject.text}</h2>
                    <div className="icons-container">
                      {selProject.email && <div className="email-icon" />}
                      {selProject.apple && <div className="apple-icon" onClick={() => window.open(selProject.apple)} />}
                      {selProject.play && <div className="play-icon" onClick={() => window.open(selProject.play)} />}
                      {selProject.site && <div className="site-icon" onClick={() => window.open(selProject.site)} />}
                    </div>
                  </div>
                  <div
                    className="project-image"
                    style={{
                      backgroundImage: `url(${selProject.imageUrl})`,
                    }}
                  />
                </div>
              ) : (
                <Form />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  headerStatus: state.stateControl.headerStatus,
  currentStatus: state.stateControl.currentStatus,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentStatus: (payload) => dispatch(setCurrentStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
